import { requestPost } from '../services/real.backend';
import usersStorage from '../pages/Users/usersStorage';
import authStorage from '../storages/mobx/authStorage';

const logErrorToMyService = (error, errorInfo) => {
  requestPost('/api/logging/log', {
    url: window.location.href,
    message: error.message || 'Empty error message',
    name: error.name || 'Noname',
    stack: error.stack ? JSON.stringify(error.stack) : 'Empty stack',
    errorInfo: JSON.stringify(errorInfo),
    browser: JSON.stringify({
      appCodeName: navigator.appCodeName,
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      cookieEnabled: navigator.cookieEnabled,
      platform: navigator.platform,
      userAgent: navigator.userAgent,
      deviceMemory: navigator.deviceMemory,
      hardwareConcurrency: navigator.hardwareConcurrency,
      language: navigator.language,
      languages: navigator.languages,
      onLine: navigator.onLine,
      product: navigator.product,
      productSub: navigator.productSub,
      vendor: navigator.vendor,
      vendorSub: navigator.vendorSub,
      screenWidth: screen.width,
      screenHeight: screen.height,
      windowWidth: window.width,
      windowHeight: window.height,
    }),
    user: JSON.stringify(authStorage),
  })
    .then(() => false);
  // console.log('ERROR:', error, errorInfo);
};

export default logErrorToMyService;
